/**
 * Carousel Big Title Block JavaScript
 */

(function () {
    "use strict";
  
    // Initialize block functionality
    function initTwoAccordions() {
      const blocks = document.querySelectorAll(".two-accordions");
  
      blocks.forEach((block) => {
        // Initialize accordion functionality for all accordions in the block
        const accordions = block.querySelectorAll(".accordion");
        accordions.forEach((accordion) => {
          initAccordion(accordion);
        });
      });
    }
  
    // Initialize when DOM is ready
    if (document.readyState === "loading") {
      document.addEventListener("DOMContentLoaded", initTwoAccordions);
    } else {
      initTwoAccordions();
    }
  
    /**
     * Easing function for smooth animation
     * @param {number} t - Progress from 0 to 1
     * @returns {number} - Eased value
     */
    function easeOutCubic(t) {
      return 1 - Math.pow(1 - t, 3);
    }
  
    /**
     * Animate accordion content smoothly
     * @param {HTMLElement} content - The content element to animate
     * @param {number} startHeight - Starting height
     * @param {number} endHeight - Ending height
     * @param {number} startOpacity - Starting opacity
     * @param {number} endOpacity - Ending opacity
     * @param {number} startPadding - Starting padding bottom
     * @param {number} endPadding - Ending padding bottom
     * @param {Function} onComplete - Callback when animation completes
     */
    function animateContent(
      content,
      startHeight,
      endHeight,
      startOpacity,
      endOpacity,
      startPadding,
      endPadding,
      onComplete
    ) {
      const duration = 500; // 500ms for smoother animation
      const startTime = performance.now();
      let animationFrame = null;
  
      function animate(currentTime) {
        const elapsed = currentTime - startTime;
        const progress = Math.min(elapsed / duration, 1);
        const eased = easeOutCubic(progress);
  
        const currentHeight = startHeight + (endHeight - startHeight) * eased;
        const currentOpacity = startOpacity + (endOpacity - startOpacity) * eased;
        const currentPadding =
          startPadding + (endPadding - startPadding) * eased;
  
        content.style.height = currentHeight + "px";
        content.style.opacity = currentOpacity;
        content.style.paddingBottom = currentPadding + "px";
  
        if (progress < 1) {
          animationFrame = requestAnimationFrame(animate);
        } else {
          if (endHeight > 0) {
            content.style.height = "auto";
          }
          if (onComplete) {
            onComplete();
          }
        }
      }
  
      animationFrame = requestAnimationFrame(animate);
  
      // Return function to cancel animation
      return function cancel() {
        if (animationFrame) {
          cancelAnimationFrame(animationFrame);
        }
      };
    }
  
    /**
     * Initialize accordion functionality
     * @param {HTMLElement} accordion - The accordion container element
     */
    function initAccordion(accordion) {
      const accordionItems = accordion.querySelectorAll(".accordion_item");
  
      accordionItems.forEach((item) => {
        const title = item.querySelector(".accordion_title");
        const content = item.querySelector(".accordion_content");
  
        if (title && content) {
          let currentAnimation = null;
  
          // Add click handler
          title.addEventListener("click", function () {
            const isActive = item.classList.contains("active");
  
            // Cancel any ongoing animation
            if (currentAnimation) {
              currentAnimation();
              currentAnimation = null;
            }
  
            // Close all other items
            accordionItems.forEach((otherItem) => {
              if (otherItem !== item) {
                const otherContent = otherItem.querySelector(".accordion_content");
                const otherIsActive = otherItem.classList.contains("active");
  
                if (otherIsActive && otherContent) {
                  // Cancel any ongoing animation
                  if (otherItem._currentAnimation) {
                    otherItem._currentAnimation();
                    otherItem._currentAnimation = null;
                  }
  
                  // Get current height - if it's auto, get the actual height
                  let currentHeight = otherContent.offsetHeight;
                  if (otherContent.style.height === "auto" || !otherContent.style.height) {
                    currentHeight = otherContent.scrollHeight;
                  }
                  
                  // Set explicit height before animating
                  otherContent.style.height = currentHeight + "px";
                  otherContent.style.overflow = "hidden";
  
                  // Force reflow
                  void otherContent.offsetHeight;
  
                  // Animate closed
                  otherItem._currentAnimation = animateContent(
                    otherContent,
                    currentHeight,
                    0,
                    1,
                    0,
                    20,
                    0,
                    function () {
                      otherItem.classList.remove("active");
                      otherContent.style.height = "0";
                      otherContent.style.opacity = "0";
                      otherContent.style.paddingBottom = "0";
                      otherItem._currentAnimation = null;
                    }
                  );
                }
              }
            });
  
            // Toggle current item
            if (isActive) {
              // Close current item
              // Get current height - if it's auto, get the actual height
              let currentHeight = content.offsetHeight;
              if (content.style.height === "auto" || !content.style.height) {
                currentHeight = content.scrollHeight;
              }
              
              // Set explicit height before animating
              content.style.height = currentHeight + "px";
              content.style.overflow = "hidden";
  
              // Force reflow
              void content.offsetHeight;
  
              // Animate closed
              currentAnimation = animateContent(
                content,
                currentHeight,
                0,
                1,
                0,
                20,
                0,
                function () {
                  item.classList.remove("active");
                  content.style.height = "0";
                  content.style.opacity = "0";
                  content.style.paddingBottom = "0";
                  currentAnimation = null;
                }
              );
            } else {
              // Open current item
              item.classList.add("active");
  
              // Set initial state
              content.style.height = "0";
              content.style.opacity = "0";
              content.style.paddingBottom = "0";
              content.style.overflow = "hidden";
  
              // Force reflow
              void content.offsetHeight;
  
              // Create a clone to measure height without affecting the original
              const clone = content.cloneNode(true);
              clone.style.position = "absolute";
              clone.style.visibility = "hidden";
              clone.style.height = "auto";
              clone.style.width = content.offsetWidth + "px";
              clone.style.top = "-9999px";
              clone.style.left = "-9999px";
              clone.style.opacity = "1";
              clone.style.paddingBottom = "20px";
              
              // Append clone to measure
              content.parentElement.appendChild(clone);
              
              // Force reflow
              void clone.offsetHeight;
              
              const targetHeight = clone.scrollHeight;
              
              // Remove clone
              clone.remove();
  
              // Animate open
              currentAnimation = animateContent(
                content,
                0,
                targetHeight,
                0,
                1,
                0,
                20,
                function () {
                  content.style.height = "auto";
                  content.style.overflow = "visible";
                  currentAnimation = null;
                }
              );
            }
  
            // Store animation reference
            item._currentAnimation = currentAnimation;
          });
        }
      });
    }
  
  })();
  